import React from 'react'

import { HeadingMedium, MetaText, Select } from '@pb/components'
import { getLabelFromStorage, isArketBrand, isCosBrand } from '@pb/utils'
import cn from 'classnames'

import styles from '../ProductDetail.scss'

export const ShopperProfiles = ({
  data,
  selectedValues,
  handleSelectChange,
}): React.ReactElement | null => {
  if (!isArketBrand) return null

  const shopperProfiles =
    data.catalogItem.userSettings.shopperProfiles !== null
      ? data.catalogItem.userSettings.shopperProfiles
      : null

  if (shopperProfiles && shopperProfiles.length > 0) {
    return (
      <div className={styles.reviewMyProfile}>
        {isArketBrand ? (
          <HeadingMedium Tag="h2" className={styles.borderHeader}>
            {getLabelFromStorage('profile.unreviewedproducts.review.page.my.profile')}
          </HeadingMedium>
        ) : (
          <MetaText Tag="h2" className={styles.upperCase}>
            {getLabelFromStorage('profile.unreviewedproducts.review.page.my.profile')}
          </MetaText>
        )}
        <div
          className={cn(
            styles.dropdownContainer,
            isCosBrand && styles.selectField,
            styles.selectActive,
          )}
        >
          {shopperProfiles.map((shopperProfile) => {
            const options = shopperProfile.values.map(({ label }) => ({ value: label, label }))
            const selectedValue = selectedValues[shopperProfile.label]
            return (
              <Select
                name={shopperProfile.label}
                value={selectedValue}
                options={options}
                placeholder={shopperProfile.label}
                onChange={(newValue) => handleSelectChange(shopperProfile.label, newValue)}
                shouldShowValidationIcon={false}
                className={cn(styles.dropdown, isArketBrand && styles.dropdownSelect)}
              />
            )
          })}
        </div>
      </div>
    )
  }
  return null
}
